import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  students: [],
  studentDetails: null,
  studentCousesDetails: null,
  studentProfileDetails: {},
  countriesList: [],
  stateList: [],
  termGoals: [],
  classList: [],
  cityList: [],
  currentCityList: [],
  studentListByCourseBatchId: [],
  allIdCardsLoading: false,
  allIdCardsSuccess: {},
  allIdCardsError: '',
  headOfcRegistraionListLoading: false,
  headOfcRegistraionListSuccess: {},
  headOfcRegistraionListError: ''

}

export const StudentSlice = createSlice({
  name: 'students',
  initialState,
  reducers: {
    getAllStudents: (state, action) => {
      state.students = action.payload;
    },
    setStudentDetails: (state, action) => {
      state.studentDetails = action.payload
    },
    setStudentCoursesDetails: (state, action) => {
      state.studentCousesDetails = action.payload
    },
    resetStudentDetails: (state) => {
      state.studentDetails = null
    },
    setStudentProfileDetails: (state, action) => {
      state.studentProfileDetails = action.payload.data
    },
    getStateList: (state, action) => {
      state.stateList = action.payload.data.map((item, index) => ({ ...item }))
    },
    getTermGoals: (state, action) => {
      state.termGoals = action.payload.data.map((item, index) => ({ ...item, label: item.title, id: item.id }))
    },
    getCityList: (state, action) => {
      state.cityList = action.payload.data.map((item, index) => ({ ...item }))
    },
    getAcedemicYearList: (state, action) => {
      state.acedemicYearList = action.payload.data?.map((item, index) => ({ ...item }))
    },
    getCurrentAddressCityList: (state, action) => {
      state.currentCityList = action.payload.data.map((item, index) => ({ ...item }))
    },
    getClassList: (state, action) => {
      state.classList = action.payload.data.map((item, index) => ({ ...item }))
    },
    setStudentByBatchCourseId: (state, action) => {
      state.studentListByCourseBatchId = action.payload.data.map((item) => ({ ...item, label: item.name, value: item.id }))
    },
    setAllIdCardsLoading: (state, action) => {
      state.allIdCardsLoading = true;
      state.allIdCardsSuccess = null;
      state.allIdCardsError = '';
    },
    setAllIdCardsSuccess: (state, action) => {
      state.allIdCardsLoading = false;
      state.allIdCardsSuccess = action.payload;
      state.allIdCardsError = '';
    },
    setAllIdCardsError: (state, action) => {
      state.allIdCardsLoading = false;
      state.allIdCardsSuccess = null;
      state.allIdCardsError = action.payload;
    },
    setHeadOfcRegistraionListLoading: (state, action) => {
      state.headOfcRegistraionListLoading = true;
      state.headOfcRegistraionListSuccess = null;
      state.headOfcRegistraionListError = '';
    },
    setHeadOfcRegistraionListSuccess: (state, action) => {
      state.headOfcRegistraionListLoading = false;
      state.headOfcRegistraionListSuccess = action.payload;
      state.headOfcRegistraionListError = '';
    },
    setHeadOfcRegistraionListError: (state, action) => {
      state.headOfcRegistraionListLoading = false;
      state.headOfcRegistraionListSuccess = null;
      state.headOfcRegistraionListError = action.payload;
    },

  },
})

export const { getAllStudents, setStudentDetails, setStudentCoursesDetails,
  resetStudentDetails, setStudentProfileDetails,
  setAllIdCardsLoading, setAllIdCardsSuccess, setAllIdCardsError,
  getCountriesList, getStateList, getTermGoals, setStudentByBatchCourseId, getCityList, getCurrentAddressCityList, getClassList, getAcedemicYearList,
  setHeadOfcRegistraionListLoading, setHeadOfcRegistraionListSuccess, setHeadOfcRegistraionListError } = StudentSlice.actions

export default StudentSlice.reducer;